<template>


  <Tabs class="flex-column flex-md-row" style="width: 100%; color: black;">
    <div v-if="getUser.user_type !== 1">
      <h2 >Багшийн хичээл</h2>
      <LessonLists :courses="teacherCourses" userType="teacher" />
      <hr v-if="getUser.user_type === 2" />
    </div>
    <div v-if="getUser.user_type !== 3">
      <h2 >Хичээлийн захиалга</h2>
      <LessonLists :courses="studentCourses" userType="other" />
    </div>
  </Tabs>


</template>

<script>
import { ref } from "vue";
import axios from "axios";
import Tabs from "@/components/Tabs/Tabs.vue";
import TabPane from "@/components/Tabs/TabPane.vue";
import LessonLists from "@/components/lesson/LessonLists.vue";
import { mapGetters, mapActions } from "vuex";

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
const testData = [
];

export default {
  name: "UserLessons",
  components: {
    Tabs,
    TabPane,
    LessonLists,
  },
  computed: {
    ...mapGetters("auth", ["isAuthenticated"]),
    ...mapGetters("auth", ["getUser"]),
  },
  data() {
    return {
      teacherCourses: [],
      studentCourses: [],
      lessonTypes: ["Бүгд", "Татвар", "Маркетинг", "Санхүү"],
      activeTab: 0, // Tracks the currently active tab
      error: null,
    };
  },

  methods: {
    async fetchTeacherLessons() {
      if (this.getUser.user_type >= 2) {
        try {
          const response = await axios.get("/lessons/teacher");
          if (response.data.items)
            this.teacherCourses = response.data.items;
          console.log("this.teacherCourses", this.teacherCourses);
        } catch (error) {
          console.error("Error fetching teacher lessons:", error);
          this.teacherCourses = testData;
        }
      } else this.teacherCourses = [];
    },
    async fetchStudentLessons() {
      if (this.getUser.user_type !== 3) {
        try {
          const response = await axios.get("/lessons/student");
          if (response.data.items)
            this.studentCourses = response.data.items;

          console.log("this.studentCourses", this.studentCourses);
        } catch (error) {
          console.error("Error fetching student lessons:", error);
          this.studentCourses = testData;
        }
      }
    },
  },

  created() {
    this.fetchTeacherLessons();
    this.fetchStudentLessons();
  },
};
</script>
